import { HttpService, createHttpService } from '@/services/HttpService';

type ServerSelfServiceMode = {
  ancestral_access: boolean;
};

export class SelfServiceModeService {
  constructor(
    private tenantUuid: string,
    private httpService: HttpService
  ) {

  }

  public async getSelfServiceMode(): Promise<boolean> {
    try {
      const serverSelfServiceMode: ServerSelfServiceMode = await this.httpService.get<void, ServerSelfServiceMode>(
        `/api/2/tenants/${this.tenantUuid}`
      );
      return !serverSelfServiceMode.ancestral_access;
    } catch (error) {
      return false;
    }
  }
}

export function createSelfServiceModeService(selfTenantUuid: string, tenantUuid: string): SelfServiceModeService {
  const httpService: HttpService = createHttpService(selfTenantUuid);

  return new SelfServiceModeService(tenantUuid, httpService);
}
